"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.LockIcon = exports.HeadsetIcon = exports.EndCallIcon = exports.MicOffIcon = exports.MicIcon = void 0;
var react_1 = __importDefault(require("react"));
// Stroke icons from the design canvas; colour follows `currentColor`.
var Svg = function (_a) {
    var size = _a.size, children = _a.children, filled = _a.filled;
    return (react_1["default"].createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: filled ? 'currentColor' : 'none', stroke: filled ? 'none' : 'currentColor', strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" }, children));
};
exports.MicIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 22 : _b;
    return (react_1["default"].createElement(Svg, { size: size },
        react_1["default"].createElement("rect", { x: "9", y: "3", width: "6", height: "11", rx: "3" }),
        react_1["default"].createElement("path", { d: "M5 11a7 7 0 0 0 14 0" }),
        react_1["default"].createElement("path", { d: "M12 18v3" })));
};
exports.MicOffIcon = function () { return (react_1["default"].createElement(Svg, { size: 22 },
    react_1["default"].createElement("path", { d: "M9 9v2a3 3 0 0 0 5.1 2.1" }),
    react_1["default"].createElement("path", { d: "M15 9.3V6a3 3 0 0 0-5.7-1.3" }),
    react_1["default"].createElement("path", { d: "M5 11a7 7 0 0 0 11.2 5.6" }),
    react_1["default"].createElement("path", { d: "M19 11a7 7 0 0 1-.6 2.8" }),
    react_1["default"].createElement("path", { d: "M12 18v3" }),
    react_1["default"].createElement("path", { d: "M3 3l18 18" }))); };
exports.EndCallIcon = function () { return (react_1["default"].createElement(Svg, { size: 24, filled: true },
    react_1["default"].createElement("path", { d: 'M2.6 13.9c5.2-4.6 13.6-4.6 18.8 0 .5.4.6 1.1.2 1.6l-1.4 1.9c-.4.5-1 .7-1.6.5' +
            'l-2.6-.9c-.5-.2-.9-.7-.9-1.3l-.1-1.6c-1.9-.5-4-.5-6 0l-.1 1.6c0 .6-.4 1.1-.9 1.3' +
            'l-2.6.9c-.6.2-1.2 0-1.6-.5l-1.4-1.9c-.4-.5-.3-1.2.2-1.6z' }))); };
exports.HeadsetIcon = function () { return (react_1["default"].createElement(Svg, { size: 30 },
    react_1["default"].createElement("path", { d: "M4 15v-3a8 8 0 0 1 16 0v3" }),
    react_1["default"].createElement("rect", { x: "3", y: "14", width: "4", height: "6", rx: "1.5" }),
    react_1["default"].createElement("rect", { x: "17", y: "14", width: "4", height: "6", rx: "1.5" }))); };
exports.LockIcon = function () { return (react_1["default"].createElement(Svg, { size: 30 },
    react_1["default"].createElement("rect", { x: "5", y: "11", width: "14", height: "10", rx: "2.5" }),
    react_1["default"].createElement("path", { d: "M8 11V8a4 4 0 0 1 8 0v3" }),
    react_1["default"].createElement("path", { d: "M12 15v2" }))); };
